export const IMAGE_EXTENSIONS = {
    PNG: 'image/png',
    JPEG: 'image/jpeg',
}